import { BaseRepository } from '../../../infra/base.repository'
import { ConfigService } from '../../../infra/config'
import type { MediaEntity } from './media.entity'

export class MediasRepository extends BaseRepository<MediaEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/academy/medias', token, cache)
    }

    async getPublic(mediaId: string) {
        const url = this.config.toolsApiUrl + '/academy/medias/' + mediaId + '/public?token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
